import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { candidates } from '@/data/mockData';
import { CandidateCard } from '@/components/candidates/CandidateCard';
import { CandidateProfile } from '@/components/candidates/CandidateProfile';
import type { Candidate } from '@/data/mockData';
import { useState } from 'react';
import { toast } from 'sonner';
import { Briefcase } from 'lucide-react';

const HiredPage = () => {
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null>(null);
  const [profileOpen, setProfileOpen] = useState(false);

  const hiredCandidates = candidates.filter((c) => c.status === 'hired');

  const handleViewProfile = (candidate: Candidate) => {
    setSelectedCandidate(candidate);
    setProfileOpen(true);
  };

  const handleShortlist = () => {
    toast.info('This candidate has already been hired!');
  };

  const handleScheduleInterview = () => {
    toast.info('This candidate has already been hired!');
  };

  const handleAssignTask = () => {
    toast.info('This candidate has already been hired!');
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Briefcase className="h-6 w-6 text-success" />
            Hired Candidates
          </h1>
          <p className="text-muted-foreground">
            Successfully hired candidates from your recruitment process.
          </p>
        </div>

        {hiredCandidates.length === 0 ? (
          <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border py-12">
            <Briefcase className="h-12 w-12 text-muted-foreground" />
            <p className="mt-2 text-lg font-medium text-muted-foreground">No hired candidates yet</p>
            <p className="text-sm text-muted-foreground">
              Complete the hiring process to see candidates here.
            </p>
          </div>
        ) : (
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {hiredCandidates.map((candidate) => (
              <CandidateCard
                key={candidate.id}
                candidate={candidate}
                onViewProfile={handleViewProfile}
                onShortlist={handleShortlist}
                onScheduleInterview={handleScheduleInterview}
              />
            ))}
          </div>
        )}
      </div>

      <CandidateProfile
        candidate={selectedCandidate}
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        onShortlist={handleShortlist}
        onScheduleInterview={handleScheduleInterview}
        onAssignTask={handleAssignTask}
      />
    </DashboardLayout>
  );
};

export default HiredPage;
